import {
  useMutation,
  useQueryClient,
  UseMutationOptions,
} from "@tanstack/react-query";
import { axiosInterceptor } from "..";
import { IResponse, UpdateSubscriptionData } from "../interface";
import { AxiosError } from "axios";

interface UpdateSubscriptionResponse {
  success: boolean;
}

type IUseUpdateSubscriptionOptions = UseMutationOptions<
  IResponse<UpdateSubscriptionResponse>,
  AxiosError<IResponse<string>>,
  UpdateSubscriptionData
>;

const useUpdateSubscription = (options?: IUseUpdateSubscriptionOptions) => {
  const queryClient = useQueryClient();

  return useMutation<
    IResponse<UpdateSubscriptionResponse>,
    AxiosError<IResponse<string>>,
    UpdateSubscriptionData
  >({
    mutationFn: async (subscriptionData: UpdateSubscriptionData) => {
      const res = await axiosInterceptor.post(
        "b2b-payment/update-subscription",
        subscriptionData
      );
      return res.data;
    },
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: ["organisation"] });
      await queryClient.invalidateQueries({
        queryKey: ["single-organization", variables.organizationId],
      });

      await queryClient.refetchQueries({ queryKey: ["organisation"] });
      await queryClient.refetchQueries({
        queryKey: ["single-organization", variables.organizationId],
      });

      options?.onSuccess?.(data, variables, context);
    },
  });
};

export default useUpdateSubscription;
